import React from 'react';

class OptionSelect extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: this.props.keyName,
      text: this.props.text,
      valueSelected: this.props.valueSelected
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      text: nextProps.text,
      value: nextProps.keyName,
      valueSelected: this.props.valueSelected
    },() => {
      this.checkSelectedItem();
    })
  }

  checkSelectedItem() {
    if(this.state.value == this.state.valueSelected) {
      this.setState({
        selected: true
      })
    } else {
      this.setState({
        selected: false
      })
    }
  }

  handleSelect() {
    let data = {
      target: {
        text: this.state.text,
        value: this.state.value
      }
    }
    this.props.selectedOption(data)
  }

  render() {
    return (
      <span className={this.state.selected ? 'rs-option selected' : 'rs-option'} onClick={this.handleSelect.bind(this)}>{this.state.text}</span>
    );
  }
}

OptionSelect.defaultProps = {
  text: '',
  value: ''
}

export default OptionSelect;


// WEBPACK FOOTER //
// ./components/partials/select/OptionSelect.jsx